import dayjs from "dayjs";
import dayjsEn from "dayjs/locale/en";
import dayjsRu from "dayjs/locale/ru";
import dayjsEs from "dayjs/locale/es";

export const setDatesLocale = (locale) => {
    dayjs.locale(locale);
}

export const formatDate = (date) => {
    return dayjs(date).format("DD.MM.YYYY HH:mm");
}

export const formatRepetitionDate = (date) => {
    return dayjs(date).format("D MMMM");
}
